import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { withRouter } from 'react-router';
import * as SurveyStateController from '../../../store/StateControllers/Survey/SurveyStateController';
import "./../styles.css";
import { SurveyProps } from '../CreateAndEditSurveys';
import { SurveyMode } from '../../../store/Models/Surveys/SurveyDataModel';
import { ToxnotSignInRequiredComponent } from '../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../../store/Models/UserContext';


class CreateAndEditSurveyRemindersPage extends ToxnotSignInRequiredComponent<SurveyProps>{
    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }

    protected renderConcreteComponent() {
        const isObtainment = this.props.appServices.userContext?.userCapabilities.obtainmentServicesEnabled ?? false;
        return (
            <div className="grouped-data">
                <div className="group">
                    <div className="title">
                        {this.localizeString("Create Reminders")}
                    </div>
                    <div className="content">
                        <div className="tn-section-row form-group">
                            <div className="tn-section-col-4">
                                <label>{this.props.surveyUi.currentState === SurveyMode.Template ? this.localizeString("Number of days after request:") : this.localizeString("Request Date")}</label>
                                {this.props.surveyUi.currentState === SurveyMode.Template ? 
                                    <input className="form-control" id="reminder-days" type="number" min="1" disabled={isObtainment}/> : 
                                    <input className="form-control" id="reminder-date" type="date" disabled={isObtainment}/>
                                }
                            </div>
                           
                        </div>
                        <div className="form-group">
                            <label>{this.localizeString("Reminder Message")}</label>
                            <textarea className="form-control" id="new-reminder-message" rows={5} placeholder="" disabled={isObtainment}/>
                        </div>
                        <div className="alert alert-danger initially-hidden" id="new-reminder-message-alert" role="alert">{this.localizeString("The reminder message can't be empty!")}</div>
                        <div className="alert alert-danger initially-hidden" id="reminder-duplicate-alert" role="alert">{this.localizeString("You can't schedule two reminders for the same day!")}</div>
                        <div className="alert alert-danger initially-hidden" id="reminder-days-alert" role="alert">{this.localizeString("The reminder days has to be greater than 0.")}</div>
                        <div className="alert alert-danger initially-hidden" id="reminder-date-alert" role="alert">{this.localizeString("The reminder date can't be empty!")}</div>
                        {this.getUserContextForSignedInUser().isEditor &&
                            <div className="form-group">
                                <button type="button" onClick={e => this.addReminders(e)} className="btn btn-toxnot-primary" disabled={isObtainment}>{this.localizeString("Add Reminder")}</button>
                            </div>
                        }
                    </div>
                </div>
                <div className="group">
                    <div className="title">
                        {this.localizeString("Scheduled Reminders")}
                    </div>
                    <div className="content">
                        <div className="tn-section-row">
                            <table className="table toxnot-table-v2">
                                <thead>
                                    <tr>
                                        <td><a role="button">{this.localizeString("Schedule")}</a></td>
                                        <td><a role="button">{this.localizeString("Message")}<span className="language-tag">{this.props.appServices.getLocalizedDisplayNameForCultureName(this.props.surveyUi.currentLanguage)}</span></a></td>
                                        <td><a role="button">{this.localizeString("Actions")}</a></td>
                                    </tr>
                                </thead>
                                <tbody id="reminder-table-body">
                                    {this.renderReminderRows(isObtainment)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {isObtainment && this.renderPastReminders()}
            </div>
        );
    }

    // ===============================================================================

    private renderReminderRows(isObtainment: boolean) {
        let reminders: JSX.Element[] = [];
        this.props.surveyRequest.scheduledReminders.sort((a, b) => {
            if (a.scheduledDaysSinceRequestSent !== undefined && b.scheduledDaysSinceRequestSent !== undefined) {
                return a.scheduledDaysSinceRequestSent > b.scheduledDaysSinceRequestSent ? 0 : -1
            } else {
                return a.scheduledSendDate > b.scheduledSendDate ? 0 : -1
            }
        }).map((data, i) => {
            let dateToUse = null;
            if (data.scheduledSendDate === null) {
                const now = new Date();
                dateToUse = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
                dateToUse.setDate(dateToUse.getDate() + data.scheduledDaysSinceRequestSent)
            } else {
                dateToUse = data.scheduledSendDate;
            }
            const date = new Date(dateToUse);
            reminders.push(
                <tr key={i.toString()}>
                    <td>{this.props.surveyUi.currentState === SurveyMode.Template ? data.scheduledDaysSinceRequestSent + " day(s) after request sent." : date.toLocaleDateString()}</td>
                    <td><textarea rows={4} className="form-control" onChange={isObtainment ? undefined : e => this.props.editReminderMessage(i, e.target.value)} readOnly={isObtainment} value={data.languageToReminderMessageMap[this.props.surveyUi.currentLanguage]}></textarea></td>
                    <td><button type="button" onClick={e => this.removeReminders(e, i)} className="btn btn-sm btn-danger" data-index={i} disabled={isObtainment}><span className="glyphicon glyphicon-remove"></span></button></td>
                </tr>
            )
        });

        if (this.props.surveyRequest.scheduledReminders.length < 1) {
            reminders.push(<tr key={"No Reminders"}><td>{this.localizeString("No Reminders Scheduled")}</td></tr>)
        }

        return reminders;
    }

    // ===============================================================================

    private renderPastReminders() {
        const compliReminderHistory = this.props.surveyRequest.metadata?.compliReminderHistory ?? [];
        return (
            <div className="group">
                <div className="title">
                    {this.localizeString("Past Reminders")}
                </div>
                <div className="content">
                    <div className="tn-section-row">
                        <table className="table toxnot-table-v2">
                            <thead>
                                <tr>
                                    <td><a role="button">{this.localizeString("Date Sent")}</a></td>
                                    <td><a role="button">{this.localizeString("Message")}</a></td>
                                </tr>
                            </thead>
                            <tbody>
                                {compliReminderHistory.length === 0
                                    ? <tr key="no-past-reminders"><td colSpan={2}>{this.localizeString("No past reminders.")}</td></tr>
                                    : compliReminderHistory.map((record, i) => (
                                        <tr key={i.toString()}>
                                            <td>{new Date(record.sentDate).toLocaleDateString()}</td>
                                            <td><pre className="form-control" style={{ whiteSpace: 'pre-wrap', height: 'auto' }}>{record.message}</pre></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    private addReminders(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        $("#new-reminder-message-alert").hide();
        $("#reminder-date-alert").hide();
        $("#reminder-days-alert").hide();
        $("#reminder-duplicate-alert").hide();

        const message = $("#new-reminder-message").val()?.toString();
        let date: string;

        if (this.props.surveyUi.currentState === SurveyMode.Template) {
            date = $("#reminder-days").val()?.toString() ?? "";
            if (date.length === 0) {
                $("#reminder-days-alert").show();
                return;
            }
            if ((Number.parseInt(date) || -1) <= 0) {
                $("#reminder-days-alert").show();
                return;
            }
        } else {
            date = $("#reminder-date").val()?.toString() ?? "";
            if (date.length === 0) {
                $("#reminder-date-alert").show();
                return;
            }
        }

        if (this.checkForDuplicateReminders(date)) {
            $("#reminder-duplicate-alert").show();
            return;
        }

        if (message?.length === 0) {
            $("#new-reminder-message-alert").show();
        }
        if (!(message === undefined || date === undefined) && !(message.length === 0 || date.length === 0)) {
            this.props.addReminder(date, message);
        }
    }

    // ===============================================================================

    private removeReminders(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, index: number) {
        if (!(index === undefined)) {
            this.props.removeReminder(index);
        }
    }

    // ===============================================================================

    private checkForDuplicateReminders(date: string): boolean {

        let scheduledDaysSinceRequestSince: number = 0;
        let scheduledDate: Date = new Date();

        if (this.props.surveyUi.currentState === SurveyMode.Template) {
            const now = new Date();
            scheduledDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            scheduledDate.setDate(scheduledDate.getDate() + Number.parseInt(date));
            scheduledDaysSinceRequestSince = Number.parseInt(date);

        } else {
            const splits = date.split('-').map(s => parseInt(s));
            const scheduledSendDate = new Date(splits[0], splits[1] - 1, splits[2]);
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            scheduledDate = scheduledSendDate;
            scheduledDaysSinceRequestSince = Math.ceil((scheduledSendDate.getTime() - today.getTime()) / 1000.0 / 60.0 / 60.0 / 24.0) - 1
        }

        for (const reminders of this.props.surveyRequest.scheduledReminders) {
            if (reminders.scheduledDaysSinceRequestSent === scheduledDaysSinceRequestSince || reminders.scheduledSendDate === scheduledDate.getTime()) {
                return true;
            }
        }

        return false;

    }

}


export default connect(
    (state: ApplicationState) => ({ ...state.createAndEditSurveysState, appServices: state.appServices }),
    SurveyStateController.actionCreators
)(withRouter(CreateAndEditSurveyRemindersPage) as any);